/**
 * Auto-generated by optimize-assets. DO NOT EDIT.
 */

// prettier-ignore
export const IMAGE_SIZES: Record<string, { full: number; half: number }> = {
  'images/contest-info-bg.png': { full: 1000, half: 500 },
  'images/contest-info-over.png': { full: 790, half: 395 },
  'images/contest-info.png': { full: 837, half: 419 },
  'images/contest-price.png': { full: 981, half: 491 },
  'images/choice-1-bg.png': { full: 857, half: 429 },
  'images/choice-1-border-active.png': { full: 857, half: 429 },
  'images/choice-1-border.png': { full: 857, half: 429 },
  'images/choice-2-bg.png': { full: 857, half: 429 },
  'images/choice-2-border-active.png': { full: 857, half: 429 },
  'images/choice-2-border.png': { full: 857, half: 429 },
  'images/stopa-leva.png': { full: 305, half: 153 },
  'images/stopa-prava.png': { full: 305, half: 153 },
  'images/visit-also-01.jpg': { full: 1000, half: 500 },
  'images/visit-also-02.jpg': { full: 1000, half: 500 },
  'images/visit-also-03.jpg': { full: 1000, half: 500 },
  'scenes/bratrstvo-za-rohem/bg.png': { full: 1000, half: 500 },
  'scenes/bratrstvo-za-rohem/bubble-1.png': { full: 711, half: 356 },
  'scenes/bratrstvo-za-rohem/bubble-2.png': { full: 905, half: 453 },
  'scenes/cervenacek-basti-dort/bg.png': { full: 1000, half: 500 },
  'scenes/cervenacek-basti-dort/ruka-leva.png': { full: 569, half: 285 },
  'scenes/cervenacek-basti-dort/ruka-prava.png': { full: 869, half: 435 },
  'scenes/cervenacek-nasel-stopy/bg.png': { full: 982, half: 491 },
  'scenes/cervenacek-nasel-stopy/bubble-1.png': { full: 689, half: 345 },
  'scenes/cervenacek-nasel-stopy/bubble-2.png': { full: 695, half: 348 },
  'scenes/cervenacek-ridi-bugatku/bg.png': { full: 1000, half: 500 },
  'scenes/cervenacek-ridi-bugatku/hlava.png': { full: 510, half: 255 },
  'scenes/cervenacek-ridi-bugatku/sala.png': { full: 521, half: 261 },
  'scenes/cervenacek-se-pta/bg.png': { full: 679, half: 340 },
  'scenes/cervenacek-se-pta/bubble-1.png': { full: 622, half: 311 },
  'scenes/jarka-chvali/bg.png': { full: 1000, half: 500 },
  'scenes/jarka-chvali/bubble-1.png': { full: 822, half: 411 },
  'scenes/jarka-ruce-v-bok/bg.png': { full: 1000, half: 500 },
  'scenes/jarka-ruce-v-bok/bubble-1.png': { full: 1000, half: 500 },
  'scenes/jarka-rychlonozka/bg.png': { full: 1000, half: 500 },
  'scenes/jarka-rychlonozka/bubble-1.png': { full: 1000, half: 500 },
  'scenes/jarka-ukoluje/bg.png': { full: 1000, half: 500 },
  'scenes/jarka-ukoluje/bubble-1.png': { full: 525, half: 263 },
  'scenes/jarka-ukoluje/bubble-2.png': { full: 720, half: 360 },
  'scenes/jarka-ukoluje/bubble-3.png': { full: 938, half: 469 },
  'scenes/je-po-desti/bg.png': { full: 1000, half: 500 },
  'scenes/je-po-desti/bubble-1.png': { full: 646, half: 323 },
  'scenes/je-po-desti/bubble-2.png': { full: 705, half: 353 },
  'scenes/jindra-a-mirek-uklidnuji/bg.png': { full: 1000, half: 500 },
  'scenes/jindra-a-mirek-uklidnuji/bubble-1.png': { full: 443, half: 222 },
  'scenes/jindra-a-mirek-uklidnuji/bubble-2.png': { full: 564, half: 282 },
  'scenes/jindra-ma-provaz/bg.png': { full: 1000, half: 500 },
  'scenes/jindra-ma-provaz/bubble-1.png': { full: 515, half: 258 },
  'scenes/jindra-se-divi/bg.png': { full: 959, half: 480 },
  'scenes/jindra-se-divi/bubble-1.png': { full: 610, half: 305 },
  'scenes/jindra-se-divi/bubble-2.png': { full: 754, half: 377 },
  'scenes/jindra-ukazuje/bg.png': { full: 1000, half: 500 },
  'scenes/jindra-ukazuje/bubble-1.png': { full: 497, half: 249 },
  'scenes/jindra-ukazuje/bubble-2.png': { full: 432, half: 216 },
  'scenes/jindra-uvadi-hru/bg.png': { full: 1000, half: 500 },
  'scenes/jindra-uvadi-hru/bubble-1.png': { full: 972, half: 486 },
  'scenes/kluci-mezi-skalami/bg.png': { full: 1000, half: 500 },
  'scenes/kluci-mezi-skalami/postavy-nositka.png': { full: 133, half: 67 },
  'scenes/kluci-mezi-skalami/postavy-stolicka.png': { full: 133, half: 67 },
  'scenes/kluci-mezi-skalami/vetev-vlevo.png': { full: 605, half: 303 },
  'scenes/kluci-mezi-skalami/vetev-vpravo.png': { full: 776, half: 388 },
  'scenes/konec-poklad/bg.png': { full: 1000, half: 500 },
  'scenes/konec-poklad/poklad.png': { full: 467, half: 234 },
  'scenes/minihra-asociace/bg-edge.png': { full: 1000, half: 500 },
  'scenes/minihra-asociace/bubble-bota.png': { full: 707, half: 354 },
  'scenes/minihra-asociace/bubble-klavir.png': { full: 577, half: 289 },
  'scenes/minihra-asociace/bubble-lopatka.png': { full: 711, half: 356 },
  'scenes/minihra-asociace/bubble-mrkev.png': { full: 617, half: 309 },
  'scenes/minihra-asociace/bubble-sandaly.png': { full: 581, half: 291 },
  'scenes/minihra-asociace/bubble-trenyrky.png': { full: 585, half: 293 },
  'scenes/minihra-asociace/bubble-vysavac.png': { full: 638, half: 319 },
  'scenes/minihra-asociace/bubble-wrong-1.png': { full: 292, half: 146 },
  'scenes/minihra-asociace/bubble-wrong-2.png': { full: 326, half: 163 },
  'scenes/minihra-asociace/bubble-wrong-3.png': { full: 354, half: 177 },
  'scenes/minihra-asociace/items/batoh-outline.png': { full: 455, half: 228 },
  'scenes/minihra-asociace/items/batoh.png': { full: 455, half: 228 },
  'scenes/minihra-asociace/items/bota-outline.png': { full: 533, half: 267 },
  'scenes/minihra-asociace/items/bota.png': { full: 533, half: 267 },
  'scenes/minihra-asociace/items/cepice-outline.png': { full: 474, half: 237 },
  'scenes/minihra-asociace/items/cepice.png': { full: 474, half: 237 },
  'scenes/minihra-asociace/items/cinky-outline.png': { full: 538, half: 269 },
  'scenes/minihra-asociace/items/cinky.png': { full: 538, half: 269 },
  'scenes/minihra-asociace/items/cutora-outline.png': { full: 455, half: 228 },
  'scenes/minihra-asociace/items/cutora.png': { full: 455, half: 228 },
  'scenes/minihra-asociace/items/esus-outline.png': { full: 437, half: 219 },
  'scenes/minihra-asociace/items/esus.png': { full: 437, half: 219 },
  'scenes/minihra-asociace/items/jablko-outline.png': { full: 472, half: 236 },
  'scenes/minihra-asociace/items/jablko.png': { full: 472, half: 236 },
  'scenes/minihra-asociace/items/jahoda-outline.png': { full: 380, half: 190 },
  'scenes/minihra-asociace/items/jahoda.png': { full: 380, half: 190 },
  'scenes/minihra-asociace/items/klavir-outline.png': { full: 447, half: 224 },
  'scenes/minihra-asociace/items/klavir.png': { full: 447, half: 224 },
  'scenes/minihra-asociace/items/kruhy-outline.png': { full: 425, half: 213 },
  'scenes/minihra-asociace/items/kruhy.png': { full: 425, half: 213 },
  'scenes/minihra-asociace/items/lopatka-outline.png': { full: 506, half: 253 },
  'scenes/minihra-asociace/items/lopatka.png': { full: 506, half: 253 },
  'scenes/minihra-asociace/items/mic-outline.png': { full: 493, half: 247 },
  'scenes/minihra-asociace/items/mic.png': { full: 493, half: 247 },
  'scenes/minihra-asociace/items/mrkev-outline.png': { full: 538, half: 269 },
  'scenes/minihra-asociace/items/mrkev.png': { full: 538, half: 269 },
  'scenes/minihra-asociace/items/nuz-outline.png': { full: 490, half: 245 },
  'scenes/minihra-asociace/items/nuz.png': { full: 490, half: 245 },
  'scenes/minihra-asociace/items/raketa-outline.png': { full: 464, half: 232 },
  'scenes/minihra-asociace/items/raketa.png': { full: 464, half: 232 },
  'scenes/minihra-asociace/items/rukavice-outline.png': { full: 507, half: 254 },
  'scenes/minihra-asociace/items/rukavice.png': { full: 507, half: 254 },
  'scenes/minihra-asociace/items/sala-outline.png': { full: 473, half: 237 },
  'scenes/minihra-asociace/items/sala.png': { full: 473, half: 237 },
  'scenes/minihra-asociace/items/sandaly-outline.png': { full: 496, half: 248 },
  'scenes/minihra-asociace/items/sandaly.png': { full: 496, half: 248 },
  'scenes/minihra-asociace/items/sekyra-outline.png': { full: 497, half: 249 },
  'scenes/minihra-asociace/items/sekyra.png': { full: 497, half: 249 },
  'scenes/minihra-asociace/items/svetr-outline.png': { full: 517, half: 259 },
  'scenes/minihra-asociace/items/svetr.png': { full: 517, half: 259 },
  'scenes/minihra-asociace/items/svihadlo-outline.png': { full: 505, half: 253 },
  'scenes/minihra-asociace/items/svihadlo.png': { full: 505, half: 253 },
  'scenes/minihra-asociace/items/trenyrky-outline.png': { full: 506, half: 253 },
  'scenes/minihra-asociace/items/trenyrky.png': { full: 506, half: 253 },
  'scenes/minihra-asociace/items/tresen-outline.png': { full: 463, half: 232 },
  'scenes/minihra-asociace/items/tresen.png': { full: 463, half: 232 },
  'scenes/minihra-asociace/items/vysavac-outline.png': { full: 521, half: 261 },
  'scenes/minihra-asociace/items/vysavac.png': { full: 521, half: 261 },
  'scenes/minihra-asociace/items/zapalky-outline.png': { full: 466, half: 233 },
  'scenes/minihra-asociace/items/zapalky.png': { full: 466, half: 233 },
  'scenes/minihra-baleni-s-rychlonozkou/bg.png': { full: 1000, half: 500 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bryle-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bryle.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-bryle.png': { full: 712, half: 356 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-cutora.png': { full: 793, half: 397 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-chleba.png': { full: 710, half: 355 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-knizka.png': { full: 796, half: 398 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-konvice.png': { full: 772, half: 386 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-kpz.png': { full: 672, half: 336 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-kramle.png': { full: 910, half: 455 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-mic.png': { full: 786, half: 393 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-nuz.png': { full: 838, half: 419 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-nuzky.png': { full: 873, half: 437 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-provaz.png': { full: 771, half: 386 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-satek.png': { full: 848, half: 424 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-telefon.png': { full: 839, half: 420 },
  'scenes/minihra-baleni-s-rychlonozkou/items/bubble-teplaky.png': { full: 869, half: 435 },
  'scenes/minihra-baleni-s-rychlonozkou/items/cutora-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/cutora.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/chleba-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/chleba.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/knizka-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/knizka.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/konvice-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/konvice.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/kpz-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/kpz.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/kramle-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/kramle.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/mic-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/mic.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/nuz-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/nuz.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/nuzky-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/nuzky.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/provaz-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/provaz.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/satek-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/satek.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/telefon-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/telefon.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/teplaky-outline.png': { full: 550, half: 275 },
  'scenes/minihra-baleni-s-rychlonozkou/items/teplaky.png': { full: 550, half: 275 },
  'scenes/minihra-hledani-kvetin/bg.jpg': { full: 1000, half: 500 },
  'scenes/minihra-hledani-kvetin/bubble-hlavacek-1.png': { full: 652, half: 326 },
  'scenes/minihra-hledani-kvetin/bubble-hlavacek-2.png': { full: 787, half: 394 },
  'scenes/minihra-hledani-kvetin/bubble-hlavacek-3.png': { full: 596, half: 298 },
  'scenes/minihra-hledani-kvetin/bubble-jahodnik-1.png': { full: 857, half: 429 },
  'scenes/minihra-hledani-kvetin/bubble-jahodnik-2.png': { full: 759, half: 380 },
  'scenes/minihra-hledani-kvetin/bubble-jahodnik-3.png': { full: 851, half: 426 },
  'scenes/minihra-hledani-kvetin/bubble-pampeliska.png': { full: 772, half: 386 },
  'scenes/minihra-hledani-kvetin/bubble-sasanka-1.png': { full: 699, half: 350 },
  'scenes/minihra-hledani-kvetin/bubble-sasanka-2.png': { full: 599, half: 300 },
  'scenes/minihra-hledani-kvetin/bubble-sasanka-3.png': { full: 622, half: 311 },
  'scenes/minihra-hledani-kvetin/bubble-sedmikraska.png': { full: 570, half: 285 },
  'scenes/minihra-hledani-kvetin/bubble-wrong-1.png': { full: 896, half: 448 },
  'scenes/minihra-hledani-kvetin/bubble-wrong-2.png': { full: 699, half: 350 },
  'scenes/minihra-hledani-kvetin/bubble-wrong-3.png': { full: 603, half: 302 },
  'scenes/minihra-hledani-kvetin/flowers/hlavacek.png': { full: 338, half: 169 },
  'scenes/minihra-hledani-kvetin/flowers/jahodnik.png': { full: 342, half: 171 },
  'scenes/minihra-hledani-kvetin/flowers/pampeliska.png': { full: 364, half: 182 },
  'scenes/minihra-hledani-kvetin/flowers/sasanka.png': { full: 342, half: 171 },
  'scenes/minihra-hledani-kvetin/flowers/sedmikraska.png': { full: 331, half: 166 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-1.png': { full: 713, half: 357 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-2.png': { full: 926, half: 463 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-3.png': { full: 892, half: 446 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-bazant.png': { full: 957, half: 479 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-divocak.png': { full: 984, half: 492 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-jelen.png': { full: 1000, half: 500 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-liska.png': { full: 1000, half: 500 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-veverka.png': { full: 786, half: 393 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-wrong-1.png': { full: 752, half: 376 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-wrong-2.png': { full: 831, half: 416 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-wrong-3.png': { full: 712, half: 356 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-wrong-4.png': { full: 781, half: 391 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-wrong-5.png': { full: 627, half: 314 },
  'scenes/minihra-prirazovani-stop/bubliny/bubble-zajic.png': { full: 1000, half: 500 },
  'scenes/minihra-prirazovani-stop/cary/cara-bazant.png': { full: 1000, half: 500 },
  'scenes/minihra-prirazovani-stop/cary/cara-jelen.png': { full: 894, half: 447 },
  'scenes/minihra-prirazovani-stop/cary/cara-liska.png': { full: 846, half: 423 },
  'scenes/minihra-prirazovani-stop/cary/cara-prase.png': { full: 989, half: 495 },
  'scenes/minihra-prirazovani-stop/cary/cara-veverka.png': { full: 1000, half: 500 },
  'scenes/minihra-prirazovani-stop/cary/cara-zajic.png': { full: 902, half: 451 },
  'scenes/minihra-prirazovani-stop/icon-list.png': { full: 130, half: 65 },
  'scenes/minihra-prirazovani-stop/listy/list-1.png': { full: 509, half: 255 },
  'scenes/minihra-prirazovani-stop/listy/list-2.png': { full: 543, half: 272 },
  'scenes/minihra-prirazovani-stop/listy/list-3.png': { full: 481, half: 241 },
  'scenes/minihra-prirazovani-stop/listy/list-4.png': { full: 592, half: 296 },
  'scenes/minihra-prirazovani-stop/listy/list-5.png': { full: 632, half: 316 },
  'scenes/minihra-prirazovani-stop/stopy/stopa-bazant.png': { full: 302, half: 151 },
  'scenes/minihra-prirazovani-stop/stopy/stopa-jelen.png': { full: 300, half: 150 },
  'scenes/minihra-prirazovani-stop/stopy/stopa-liska.png': { full: 302, half: 151 },
  'scenes/minihra-prirazovani-stop/stopy/stopa-prase.png': { full: 322, half: 161 },
  'scenes/minihra-prirazovani-stop/stopy/stopa-veverka.png': { full: 306, half: 153 },
  'scenes/minihra-prirazovani-stop/stopy/stopa-zajic.png': { full: 306, half: 153 },
  'scenes/minihra-prirazovani-stop/zvirata/zvire-bazant.png': { full: 342, half: 171 },
  'scenes/minihra-prirazovani-stop/zvirata/zvire-jelen.png': { full: 271, half: 136 },
  'scenes/minihra-prirazovani-stop/zvirata/zvire-liska.png': { full: 334, half: 167 },
  'scenes/minihra-prirazovani-stop/zvirata/zvire-prase.png': { full: 336, half: 168 },
  'scenes/minihra-prirazovani-stop/zvirata/zvire-veverka.png': { full: 306, half: 153 },
  'scenes/minihra-prirazovani-stop/zvirata/zvire-zajic.png': { full: 259, half: 130 },
  'scenes/mirek-a-jindra/bg.png': { full: 1000, half: 500 },
  'scenes/mirek-a-jindra/bubble-1.png': { full: 792, half: 396 },
  'scenes/mirek-a-jindra/bubble-2.png': { full: 1000, half: 500 },
  'scenes/mirek-facepalm/bg.png': { full: 1000, half: 500 },
  'scenes/mirek-facepalm/bubble-1.png': { full: 526, half: 263 },
  'scenes/mirek-facepalm/bubble-2.png': { full: 1000, half: 500 },
  'scenes/mirek-facepalm/bubble-3.png': { full: 948, half: 474 },
  'scenes/mirek-napad/bg.png': { full: 1000, half: 500 },
  'scenes/mirek-napad/bubble-1.png': { full: 742, half: 371 },
  'scenes/mirek-napad/bubble-2.png': { full: 1000, half: 500 },
  'scenes/mirek-se-divi/bg.png': { full: 1000, half: 500 },
  'scenes/mirek-se-divi/bubble-1.png': { full: 796, half: 398 },
  'scenes/mirek-se-zlobi/bg.png': { full: 1000, half: 500 },
  'scenes/mirek-se-zlobi/bubble-1.png': { full: 802, half: 401 },
  'scenes/mirek-se-zlobi/bubble-2.png': { full: 819, half: 410 },
  'scenes/mirek-se-zlobi/bubble-3.png': { full: 746, half: 373 },
  'scenes/mirek-se-zlobi/choice-1.png': { full: 857, half: 429 },
  'scenes/mirek-se-zlobi/choice-2.png': { full: 857, half: 429 },
  'scenes/mirek-ukazuje/bg.png': { full: 1000, half: 500 },
  'scenes/mirek-ukazuje/bubble-1.png': { full: 1000, half: 500 },
  'scenes/mirek-ukazuje/bubble-2.png': { full: 1000, half: 500 },
  'scenes/mirek-ukazuje/ruka.png': { full: 520, half: 260 },
  'scenes/petr-huh/bg.png': { full: 1000, half: 500 },
  'scenes/petr-huh/bubble-1.png': { full: 710, half: 355 },
  'scenes/petr-huh/bubble-2.png': { full: 817, half: 409 },
  'scenes/petr-mumla/bg.png': { full: 563, half: 282 },
  'scenes/petr-mumla/bubble-1.png': { full: 720, half: 360 },
  'scenes/petr-mumla/bubble-2.png': { full: 773, half: 387 },
  'scenes/petr-na-nositkach/bg-1.png': { full: 1000, half: 500 },
  'scenes/petr-na-nositkach/bg-2.png': { full: 1000, half: 500 },
  'scenes/petr-na-nositkach/bubble-1.png': { full: 777, half: 389 },
  'scenes/petr-na-stolicce/bg-1.png': { full: 1000, half: 500 },
  'scenes/petr-na-stolicce/bg-2.png': { full: 1000, half: 500 },
  'scenes/petr-na-stolicce/bubble-1.png': { full: 691, half: 346 },
  'scenes/petr-na-stolicce/bubble-2.png': { full: 746, half: 373 },
  'scenes/petr-na-stolicce/bubble-3.png': { full: 502, half: 251 },
  'scenes/petr-na-stolicce/bubble-4.png': { full: 808, half: 404 },
  'scenes/petr-sedi/bg.png': { full: 1000, half: 500 },
  'scenes/petr-sedi/bubble-1.png': { full: 306, half: 153 },
  'scenes/petr-sedi/bubble-2.png': { full: 585, half: 293 },
  'scenes/petr-sedi/bubble-3.png': { full: 497, half: 249 },
  'scenes/petr-sedi/bubble-4.png': { full: 433, half: 217 },
  'scenes/petr-sedi/bubble-5.png': { full: 529, half: 265 },
  'scenes/petr-sedi/bubble-6.png': { full: 505, half: 253 },
  'scenes/petr-sedi/bubble-7.png': { full: 556, half: 278 },
  'scenes/petr-sedi/bubble-8.png': { full: 607, half: 304 },
  'scenes/petr-sedi/jarka.png': { full: 474, half: 237 },
  'scenes/petr-sedi/jindra.png': { full: 298, half: 149 },
  'scenes/petr-sedi/petr-sedi-ruka.png': { full: 436, half: 218 },
  'scenes/petr-sedi/petr-sedi.png': { full: 436, half: 218 },
  'scenes/petr-vola-o-pomoc/bg.png': { full: 1000, half: 500 },
  'scenes/petr-vola-o-pomoc/bubble-1.png': { full: 402, half: 201 },
  'scenes/petr-vola-o-pomoc/bubble-2.png': { full: 716, half: 358 },
  'scenes/petr-vola-o-pomoc/bubble-3.png': { full: 597, half: 299 },
  'scenes/petr-vola-o-pomoc/bubble-4.png': { full: 1000, half: 500 },
  'scenes/petr-vola-o-pomoc/bubble-5.png': { full: 691, half: 346 },
  'scenes/petr-vola-o-pomoc/bubble-6.png': { full: 779, half: 390 },
  'scenes/prsi-bezime/bg.png': { full: 1000, half: 500 },
  'scenes/prsi-na-hlavy/bg.png': { full: 1000, half: 500 },
  'scenes/prsi-na-hlavy/bubble-1.png': { full: 714, half: 357 },
  'scenes/rychle-sipy-kraci/bg.png': { full: 1000, half: 500 },
  'scenes/rychle-sipy-kraci/cervenacek.png': { full: 265, half: 133 },
  'scenes/rychle-sipy-kraci/jarka.png': { full: 239, half: 120 },
  'scenes/rychle-sipy-kraci/jindra.png': { full: 260, half: 130 },
  'scenes/rychle-sipy-kraci/mirek.png': { full: 255, half: 128 },
  'scenes/rychle-sipy-kraci/rychlonozka.png': { full: 279, half: 140 },
  'scenes/rychle-sipy-odchazeji/bg.png': { full: 1000, half: 500 },
  'scenes/rychle-sipy-odchazeji/bubble-1.png': { full: 938, half: 469 },
  'scenes/rychle-sipy-odchazeji/bubble-2.png': { full: 926, half: 463 },
  'scenes/rychle-sipy-odchazeji/bubble-3.png': { full: 819, half: 410 },
  'scenes/rychle-sipy-odchazeji/bubble-4.png': { full: 911, half: 456 },
  'scenes/rychle-sipy-pokracuji-v-ceste/bg.png': { full: 1000, half: 500 },
  'scenes/rychle-sipy-tahaji-provaz/bg.png': { full: 1000, half: 500 },
  'scenes/rychle-sipy-tahaji-provaz/petr.png': { full: 502, half: 251 },
  'scenes/rychlonozka-basti-svacinu/bg.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-dava-svacinu/bg-1.png': { full: 706, half: 353 },
  'scenes/rychlonozka-dava-svacinu/bg-2.png': { full: 706, half: 353 },
  'scenes/rychlonozka-dava-svacinu/bubble-1.png': { full: 358, half: 179 },
  'scenes/rychlonozka-dava-svacinu/bubble-2.png': { full: 518, half: 259 },
  'scenes/rychlonozka-dava-svacinu/bubble-3.png': { full: 307, half: 154 },
  'scenes/rychlonozka-hladovi/bg.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-hladovi/bubble-1.png': { full: 622, half: 311 },
  'scenes/rychlonozka-hladovi/bubble-2.png': { full: 595, half: 298 },
  'scenes/rychlonozka-hladovi/choice-1.png': { full: 857, half: 429 },
  'scenes/rychlonozka-hladovi/choice-2.png': { full: 857, half: 429 },
  'scenes/rychlonozka-ma-provaz/bg.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-ma-provaz/bubble-1.png': { full: 515, half: 258 },
  'scenes/rychlonozka-nasel-kytku/bg.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-nasel-kytku/bubble-1.png': { full: 591, half: 296 },
  'scenes/rychlonozka-nasel-kytku/bubble-2.png': { full: 886, half: 443 },
  'scenes/rychlonozka-nema-provaz/bg.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-nema-provaz/bubble-1.png': { full: 650, half: 325 },
  'scenes/rychlonozka-nema-svacinu/bg.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-nema-svacinu/bubble-1.png': { full: 692, half: 346 },
  'scenes/rychlonozka-nema-svacinu/bubble-2.png': { full: 822, half: 411 },
  'scenes/rychlonozka-nema-svacinu/bubble-3.png': { full: 539, half: 270 },
  'scenes/rychlonozka-odmita-svacinu/bg.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-odmita-svacinu/bubble-1.png': { full: 825, half: 413 },
  'scenes/rychlonozka-odmita-svacinu/bubble-2.png': { full: 644, half: 322 },
  'scenes/rychlonozka-se-drbe/bg.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-se-drbe/bubble-1.png': { full: 600, half: 300 },
  'scenes/rychlonozka-se-drbe/bubble-2.png': { full: 866, half: 433 },
  'scenes/rychlonozka-se-drbe/bubble-3.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-vyrazi/bg.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-vyrazi/bubble-1.png': { full: 1000, half: 500 },
  'scenes/rychlonozka-vyrazi/ruka.png': { full: 609, half: 305 },
  'scenes/schody-bratrstvo/bg.png': { full: 1000, half: 500 },
  'scenes/schody-bratrstvo/bubble-1.png': { full: 474, half: 237 },
  'scenes/schody-bratrstvo/bubble-2.png': { full: 910, half: 455 },
  'scenes/schody-bratrstvo/bubble-3.png': { full: 793, half: 397 },
  'scenes/schody-bratrstvo/bubble-4.png': { full: 1000, half: 500 },
  'scenes/schody-cervenacek/bg.png': { full: 1000, half: 500 },
  'scenes/schody-cervenacek/bubble-1.png': { full: 1000, half: 500 },
  'scenes/schody-cervenacek/choice-1.png': { full: 857, half: 429 },
  'scenes/schody-cervenacek/choice-2.png': { full: 857, half: 429 },
  'scenes/schody-nohy/bg.png': { full: 1000, half: 500 },
  'scenes/schody-nohy/kabat.png': { full: 689, half: 345 },
  'scenes/schody-nohy/noha-leva.png': { full: 642, half: 321 },
  'scenes/schody-nohy/noha-prava.png': { full: 427, half: 214 },
  'scenes/schody-petr/bg.png': { full: 1000, half: 500 },
  'scenes/schody-siluety/bg.png': { full: 1000, half: 500 },
  'scenes/schody-siluety/bubble-1.png': { full: 1000, half: 500 },
  'scenes/schody-sipy-bidlo/bg.png': { full: 1000, half: 500 },
  'scenes/schody-sipy-bidlo/bidlo.png': { full: 1000, half: 500 },
  'scenes/schody-sipy-bidlo/bubble-1.png': { full: 1000, half: 500 },
  'scenes/schovani-pod-stromem/bg.png': { full: 1000, half: 500 },
  'scenes/schovani-pod-stromem/bubble-1.png': { full: 746, half: 373 },
  'scenes/schovani-pod-stromem/bubble-2.png': { full: 807, half: 404 },
  'scenes/schovani-pod-stromem/vetve-zleva.png': { full: 1000, half: 500 },
  'scenes/schovani-pod-stromem/vetve-zprava.png': { full: 1000, half: 500 },
  'scenes/ukol-ci-jsou-to-stopy/stopy.png': { full: 371, half: 186 },
  'scenes/ukol-kdo-hleda-najde/hlavacek.png': { full: 338, half: 169 },
  'scenes/ukol-kdo-hleda-najde/jahodnik.png': { full: 342, half: 171 },
  'scenes/ukol-kdo-hleda-najde/pampeliska.png': { full: 364, half: 182 },
  'scenes/ukol-kdo-hleda-najde/sasanka.png': { full: 342, half: 171 },
  'scenes/ukol-kdo-hleda-najde/sedmikraska.png': { full: 331, half: 166 },
  'scenes/ukol-kdosi-vola-o-pomoc/kpz.png': { full: 457, half: 229 },
  'scenes/ukol-kdosi-vola-o-pomoc/tisen.png': { full: 400, half: 200 },
  'scenes/ukol-rychlonozka-se-bali-na-vypravu/batoh.png': { full: 383, half: 192 },
  'scenes/ukol-tajemstvi-strazni-skaly/schody.png': { full: 660, half: 330 },
  'scenes/ukol-vyprava-zacina/vetve-vlevo.png': { full: 853, half: 427 },
  'scenes/ukol-vyprava-zacina/vetve-vpravo.png': { full: 667, half: 334 },
}

/**
 * Texture images — variants sorted descending by width.
 * { w: pixel width, s: filename suffix (empty = original) }
 */
// prettier-ignore
export const TEXTURE_SIZES: Record<string, Array<{ w: number; s: string }>> = {
  'images/texture-dark.jpg': [{ w: 3840, s: '' }, { w: 1920, s: '-1920' }, { w: 800, s: '-800' }],
  'images/texture-dirt.jpg': [{ w: 3840, s: '' }, { w: 1920, s: '-1920' }, { w: 800, s: '-800' }],
  'images/texture-grass.jpg': [{ w: 3840, s: '' }, { w: 1920, s: '-1920' }, { w: 800, s: '-800' }],
  'images/texture-light.jpg': [{ w: 3840, s: '' }, { w: 1920, s: '-1920' }, { w: 800, s: '-800' }],
  'images/texture-stone.jpg': [{ w: 3840, s: '' }, { w: 1920, s: '-1920' }, { w: 800, s: '-800' }],
}
